import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Helmet } from 'react-helmet';
import { Link, useLocation } from 'react-router-dom';
import '../App.css';

const Navbar = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const handleLinkClick = () => {
    const navbar = document.querySelector('.navbar-collapse.show');
    if (navbar) {
      const bsCollapse = new window.bootstrap.Collapse(navbar, { toggle: true });
      bsCollapse.hide();
    }
    window.scrollTo(0, 0);
  };

  const navLinks = [
    { to: '/',          label: 'Home' },
    { to: '/courses',   label: 'Courses' },
    { to: '/placement', label: 'Placement' },
    { to: '/about',     label: 'About Us' },
  ];

  const rightLinks = [
    { to: '/verify',   label: 'Verify Certificate' },
    { to: '/learning', label: 'Learning Center' },
    { to: '/calendar', label: <><i className="bi bi-calendar3 me-1"></i>Calendar</> },
  ];

  return (
    <>
      <Helmet>
        <title>Shrikant Tally Institute | Official Tally Education Partner</title>
        <meta name="description" content="Explore courses, placement opportunities, and learning resources at Shrikant Tally Institute, an authorized partner of Tally Education in Damoh." />
        <meta name="keywords" content="Shrikant Tally Institute, Tally Education, Tally courses, accounting courses, job placement, Tally certification, learning center, Damoh" />
        <meta property="og:title" content="Shrikant Tally Institute | Official Tally Education Partner" />
        <meta property="og:description" content="Explore courses, placement opportunities, and learning resources at Shrikant Tally Institute, an authorized partner of Tally Education in Damoh." />
        <meta property="og:url" content="https://shrikanttallyinstitute.com/" />
      </Helmet>

      <style>{`
        /* ── Top bar ── */
        .top-bar {
          background: #fffbe5;
          padding: 8px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #f0e8c0;
        }
        .top-bar-brand {
          font-family: 'Bahnschrift Condensed', sans-serif;
          font-size: 22px;
          font-weight: 700;
          color: #4d3d6c;
          letter-spacing: 0.3px;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 10px;
          transition: opacity 0.2s;
        }
        .top-bar-brand:hover { opacity: 0.85; color: #4d3d6c; }
        .top-bar-brand .brand-dot {
          width: 8px; height: 8px;
          background: #90b732;
          border-radius: 50%;
          display: inline-block;
        }
        .top-bar-right {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        .top-bar-contact {
          font-size: 12.5px;
          color: #666;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .top-bar-contact i { color: #90b732; }
        .tally-prime-link {
          font-family: 'Bahnschrift Condensed', sans-serif;
          font-size: 14px;
          font-weight: 700;
          color: #90b732;
          text-decoration: none;
          border: 1.5px solid #90b732;
          border-radius: 6px;
          padding: 3px 10px;
          transition: background 0.2s, color 0.2s;
        }
        .tally-prime-link:hover {
          background: #90b732;
          color: #fff;
        }

        /* ── Main nav ── */
        .main-nav {
          background: #90b732;
          position: sticky;
          top: 0;
          z-index: 1030;
          box-shadow: 0 2px 12px rgba(144,183,50,0.25);
        }
        .main-nav .navbar-toggler {
          border-color: rgba(255,255,255,0.4);
        }
        .main-nav .navbar-toggler-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255,255,255,0.9%29' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
          transition: transform 0.3s ease;
        }
        .main-nav .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
          transform: rotate(90deg);
        }

        /* nav links */
        .main-nav .nav-link {
          color: rgba(255,255,255,0.88) !important;
          font-size: 14px;
          font-weight: 500;
          padding: 10px 14px !important;
          position: relative;
          transition: color 0.2s;
        }
        .main-nav .nav-link::after {
          content: '';
          position: absolute;
          bottom: 4px; left: 50%;
          width: 0; height: 2px;
          background: #fff;
          border-radius: 2px;
          transition: width 0.25s ease, left 0.25s ease;
        }
        .main-nav .nav-link:hover { color: #fff !important; }
        .main-nav .nav-link:hover::after { width: 70%; left: 15%; }
        .main-nav .nav-link.active-link {
          color: #fff !important;
          font-weight: 700;
        }
        .main-nav .nav-link.active-link::after {
          width: 70%; left: 15%;
          background: #fff;
        }

        /* enroll button */
        .main-nav .nav-enroll-btn,
        .main-nav .nav-enroll-btn:visited {
          background: #fff !important;
          color: #90b732 !important;
          border-radius: 6px !important;
          padding: 6px 18px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          transition: background 0.2s, color 0.2s !important;
        }
        .main-nav .nav-enroll-btn:hover {
          background: #f5f5f5 !important;
          color: #6fa020 !important;
        }
        .main-nav .nav-enroll-btn::after { display: none !important; }

        /* mobile collapse */
        @media (max-width: 991.98px) {
          .main-nav .navbar-collapse {
            background: #7da82a;
            padding: 12px 16px;
            border-radius: 0 0 12px 12px;
            box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          }
          .top-bar-contact { display: none; }
        }

        /* ── Marquee ── */
        .marquee-bar {
          background: #fffbe5;
          border-top: 1px solid #f0e8c0;
          padding: 5px 0;
          overflow: hidden;
        }
        .marquee-inner {
          display: inline-block;
          white-space: nowrap;
          animation: marqueeScroll 38s linear infinite;
          font-size: 13px;
          font-weight: 600;
          color: #555;
        }
        .marquee-inner:hover { animation-play-state: paused; }
        .marquee-dot { color: #90b732; margin: 0 16px; }
        @keyframes marqueeScroll {
          0%   { transform: translateX(100vw); }
          100% { transform: translateX(-100%); }
        }
      `}</style>

      {/* ── Top Bar ── */}
      <div className="top-bar">
        <Link to="/" className="top-bar-brand" onClick={() => window.scrollTo(0,0)}>
          <span className="brand-dot"></span>
          Shrikant Tally Institute
        </Link>
        <div className="top-bar-right">
          <span className="top-bar-contact d-none d-md-flex">
            <i className="bi bi-telephone-fill"></i> 9131385180
          </span>
          <span className="top-bar-contact d-none d-lg-flex">
            <i className="bi bi-geo-alt-fill"></i> Damoh, MP
          </span>
          <a href="https://tallysolutions.com/partners/shree-enterprises/" target="_blank" rel="noopener noreferrer" className="tally-prime-link">
            Shree Enterprises ↗
          </a>
          <a href="https://tallysolutions.com/" target="_blank" rel="noopener noreferrer" className="tally-prime-link">
            TallyPrime ↗
          </a>
        </div>
      </div>

      {/* ── Main Nav ── */}
      <nav className="navbar navbar-expand-lg main-nav py-0">
        <div className="container-fluid px-4">

          <button className="navbar-toggler border-0 py-2" type="button"
            data-bs-toggle="collapse" data-bs-target="#mainNav"
            aria-controls="mainNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="mainNav">
            {/* Left links */}
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              {navLinks.map(({ to, label }) => (
                <li className="nav-item" key={to}>
                  <Link
                    to={to}
                    className={`nav-link ${isActive(to) ? 'active-link' : ''}`}
                    onClick={handleLinkClick}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Center brand */}
            <div className="mx-auto d-none d-lg-flex align-items-center gap-2">
              <img
                src={`${process.env.PUBLIC_URL}/tally.png`}
                alt="logo"
                style={{ height: 28, filter: 'brightness(0) invert(1)', opacity: 0.9 }}
              />
            </div>

            {/* Right links */}
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center gap-1">
              {rightLinks.map(({ to, label }) => (
                <li className="nav-item" key={to}>
                  <Link
                    to={to}
                    className={`nav-link ${isActive(to) ? 'active-link' : ''}`}
                    onClick={handleLinkClick}
                  >
                    {label}
                  </Link>
                </li>
              ))}
              <li className="nav-item">
                <Link to="/login" className={`nav-link ${isActive('/login') ? 'active-link' : ''}`} onClick={handleLinkClick}>
                  <i className="bi bi-person-circle me-1"></i>Login
                </Link>
              </li>
              <li className="nav-item ms-lg-2">
                <Link to="/register" className="nav-link nav-enroll-btn" style={{ color: '#90b732' }} onClick={handleLinkClick}>
                  Enroll Now
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ── Marquee ── */}
      <div className="marquee-bar">
        <div className="marquee-inner">
          <span className="marquee-dot">●</span>
          Shrikant Tally Institute is an officially verified and authorized partner of Tally Education Pvt. Ltd.
          <span className="marquee-dot">●</span>
          Offering industry-recognized certification programs in Accounting, GST &amp; TallyPrime
          <span className="marquee-dot">●</span>
          Guaranteed Placement &nbsp;·&nbsp; Expert Faculty &nbsp;·&nbsp; ISO 9001:2015 Certified
          <span className="marquee-dot">●</span>
        </div>
      </div>
    </>
  );
};

export default Navbar;
